import { render, staticRenderFns } from "./LimitationCard.vue?vue&type=template&id=016729b9&"
import script from "./LimitationCard.vue?vue&type=script&lang=js&"
export * from "./LimitationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports